import { useMemo, useState } from 'react'
import ResultadoPorEmpresaHttp from '../../../../services/api/https/dashboard/resultado-por-empresa.http'
import { getCompaniesByUserId } from '../../../../services/api/https/system/system.http'
import { getTps, getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import { getPeriodoMesAtual, parseToMysqlFormat } from '../../../../services/util/date.service'
import { errorHandler } from '../../../../services/util/error.service'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import { DateTime } from 'luxon'

const status_name = {
  aguardando_conferencia: 'Aguardando Conferência',
  picking_concluido: 'Picking Concluído',
  carregada: 'Carregada',
  conferido: 'Conferido',
  devolucao_parcial: 'Devolução Parcial',
  devolucao_total: 'Devolução Total',
  entregue: 'Entregue',
  reentrega: 'Reentrega',
  saiu_para_entrega: 'Saiu para Entrega',
}

const status_colors = {
  aguardando_conferencia: '#6750A4',
  picking_concluido: '#57c278',
  carregada: '#958DA5',
  conferido: '#B58392',
  devolucao_parcial: '#e5d457',
  devolucao_total: '#d6099d',
  entregue: '#3faf87',
  reentrega: '#9f5a7e',
  saiu_para_entrega: '#4bd9fb',
}

const colorsDefault = [
  '#C0C0C0',
  '#808080',
  '#000000',
  '#FF0000',
  '#800000',
  '#FFFF00',
  '#808000',
  '#00FF00',
  '#008000',
  '#00FFFF',
  '#008080',
  '#0000FF',
  '#000080',
  '#FF00FF',
  '#800080',
  '#CD5C5C',
  '#F08080',
  '#FA8072',
  '#E9967A',
  '#FFA07A',
]

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET: 'Adquirindo dados',
}

const indicadores = {
  qte_ciclos: 0,
  qte_entregas: 0,
  qte_caixas: 0,
  peso: 0,
  qte_faltas: 0,
  qte_sobras: 0,
  indice_faltas_sobras: 0,
  percent_devolucao_parcial: 0,
  qte_entregas_conferidas: 0,
  qte_entregas_nao_conferidas: 0,
  indice_conferidas_nao_conferidas: 0,
  percent_devolucao_total: 0,
  qte_carros_enviado_rotas: 0,
  qte_carros_retornados_rotas: 0,
  valor_nfs: 0,
  dadosExpedicao: [],
}

const graph = {
  qte_caixas_por_tp: [],
  tipos_ocorrencias: [],
  entrega_status: [],
}

const movimentacoes = {
  movimentacoes: [],
}

const ocorrencias = {
  ocorrencias: [],
}

const INITIAL_STATE = {
  dashboardInfo: {
    cardsInfo: {
      ...indicadores,
      ...graph,
    },
    ...movimentacoes,
    ...ocorrencias,
  },
  companySelected: null,
  pInicial: getPeriodoMesAtual().dataInicial,
  pFinal: getPeriodoMesAtual().dataFinal,
  companies: [],
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  colors: [],
  expandedRows: null,
  showModalProdutos: false,
  selectedRowProducts: null,
  globalFilterOco: '',
  globalFiterStatus: '',
  colorsDefault: colorsDefault,
  movimentacoes: [],
  dataTableLazyLoading: {
    movimentacoes: [],
    loading: false,
    first: 0,
    rows: 10,
    totalRecords: 0,
    pageCount: 1,
  },
}

export default function useResultadorPorEmpresa() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    const diffInDaysBetweenDates = (pInicial, pFinal) => {
      let difference = pInicial.getTime() - pFinal.getTime()
      let TotalDays = Math.ceil(difference / (1000 * 3600 * 24))
      return TotalDays * -1
    }

    return {
      createStatusColors(status_names) {
        const colors = []
        status_names.forEach(name => {
          const values = Object.values(status_name)
          const index = values.findIndex(v => v === name)
          colors.push(Object.values(status_colors)[index])
        })
        return colors
      },

      getPageData(pInicial, pFinal, companySelected, selectedTp, page) {
        if (companySelected) {
          let tpsIds = 0
          if (!selectedTp) tpsIds = getTps(false).map(tp => tp.id)
          else tpsIds = selectedTp

          ResultadoPorEmpresaHttp.getMovimentacoesPerPage(
            companySelected.map(company => company.id),
            tpsIds,
            parseToMysqlFormat(pInicial),
            parseToMysqlFormat(pFinal),
            page,
            false,
          )
            .then(result =>
              setState(prevState => ({
                ...prevState,
                movimentacoes: [...prevState.movimentacoes, ...result],
                dataTableLazyLoading: {
                  ...prevState.dataTableLazyLoading,
                  movimentacoes: result,
                  totalRecords: result.length * page + 1,
                  loading: false,
                },
              })),
            )
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                errorMessage: err,
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
        }
      },

      setExpandedRows(data) {
        setState(prevState => ({ ...prevState, expandedRows: data }))
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      showModalProdutos(value, seletecedRow = null) {
        setState(prevState => ({
          ...prevState,
          showModalProdutos: value,
          selectedRowProducts: seletecedRow ? seletecedRow.products : null,
        }))
      },

      OnGlobalFilterChange(from, value) {
        if (from === 'occorrencias')
          setState(prevState => ({ ...prevState, globalFilterOco: value }))
        else if (from === 'status')
          setState(prevState => ({ ...prevState, globalFilterStatus: value }))
        else setState(prevState => ({ ...prevState, globalFilterMov: value }))
      },

      onPage(event, totalRecords) {
        if (event.first >= totalRecords - 1) {
          setState(prevState => ({
            ...prevState,
            dataTableLazyLoading: {
              ...prevState.dataTableLazyLoading,
              rows: event.rows,
              first: event.first,
              pageCount: event.pageCount,
              loading: true,
            },
          }))
        } else {
          setState(prevState => ({
            ...prevState,
            dataTableLazyLoading: {
              ...prevState.dataTableLazyLoading,
              rows: event.rows,
              first: event.first,
              pageCount: event.pageCount,
              movimentacoes: prevState.movimentacoes.slice(event.first, event.first + event.rows),
              loading: false,
            },
          }))
        }
      },

      onChangePeriodoInicial(value) {
        setState(prevState => ({ ...prevState, pInicial: value }))
      },

      onChangePeriodoFinal(value) {
        setState(prevState => ({ ...prevState, pFinal: value }))
      },

      onBtnExportClick(data, exportFileName, pInicial, pFinal, companySelected, selectedTp, page) {
        if (exportFileName === 'Dados-Expedicao') {
          const ocorrenciasExcel = [Object.keys(data[0])]

          data.forEach(d => {
            d.data_envio_planejada = d.data_envio_planejada
              ? DateTime.fromISO(d.data_envio_planejada).toFormat('dd/MM/yyyy')
              : ''
            d.data_envio_realizada = d.data_envio_realizada
              ? DateTime.fromISO(d.data_envio_realizada).toFormat('dd/MM/yyyy HH:mm:ss')
              : ''
            d.data_retorno = d.data_retorno
              ? DateTime.fromISO(d.data_retorno).toFormat('dd/MM/yyyy HH:mm:ss')
              : ''
            d.data_operacao = d.data_operacao
              ? DateTime.fromISO(d.data_operacao).toFormat('dd/MM/yyyy')
              : ''
            ocorrenciasExcel.push(Object.values(d))
          })

          gerarArquivoExcel('sheet1', ocorrenciasExcel, exportFileName + '.xlsx')
        } else if (exportFileName === 'Movimentacoes') {
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET }))

          let tpsIds = 0
          if (!selectedTp) tpsIds = getTps(false).map(tp => tp.id)
          else tpsIds = selectedTp

          // Verificação para garantir que `companySelected` e `companySelected.id` estão definidos
          if (companySelected.length) {
            ResultadoPorEmpresaHttp.getMovimentacoesExcel(
              companySelected.map(c => c.id),
              tpsIds,
              parseToMysqlFormat(pInicial),
              parseToMysqlFormat(pFinal),
              0,
              true,
            )
              .then(res => {
                window.open(res)
                setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.NONE }))
              })
              .catch(err => setState(prevState => ({ ...prevState, errorMessage: err })))
          } else {
            console.error(
              'Erro: companySelected está undefined ou companySelected.id está undefined',
            )
            setState(prevState => ({
              ...prevState,
              errorMessage: 'Selecione uma empresa válida antes de exportar.',
            }))
          }
        } else {
          const ocorrenciasExcel = [Object.keys(data[0])]

          data.forEach(d => {
            ocorrenciasExcel.push(Object.values(d))
          })

          gerarArquivoExcel('sheet1', ocorrenciasExcel, exportFileName + '.xlsx')
        }
      },

      onCompanyChange(value) {
        setState(prevState => ({ ...prevState, companySelected: value }))
      },

      async onInit() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET }))
        await getCompaniesByUserId(getUsuarioInfo().id)
          .then(companies =>
            setState(prevState => {
              prevState.companies = companies
              prevState.loadingMessage = LOAD_MESSAGE.NONE
              return { ...prevState }
            }),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      onBtnExportExpedicao() {},

      onBtnPesquisar(pInicial, pFinal, companySelected, selectedTp) {
        let tpsIds = 0
        if (!selectedTp) tpsIds = getTps(false).map(tp => tp.id)
        else tpsIds = selectedTp

        if (!companySelected) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione uma empresa antes de fazer a pesquisa.',
          }))
          return
        }

        if (diffInDaysBetweenDates(new Date(pInicial), new Date(pFinal)) > 31) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'O intervalo maximo para analise é de 31 dias.',
          }))
          return
        }
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET }))
        ResultadoPorEmpresaHttp.getResultadoPorEmpresa(
          companySelected.map(company => company.id),
          tpsIds,
          parseToMysqlFormat(pInicial),
          parseToMysqlFormat(pFinal),
        )
          .then(result => {
            setState(prevState => ({
              ...prevState,
              dashboardInfo: result,
              movimentacoes: result.movimentacoes,
              dataTableLazyLoading: {
                ...prevState.dataTableLazyLoading,
                movimentacoes: result.movimentacoes,
                totalRecords: 10 + 1,
              },
              colors: this.createStatusColors(result.cardsInfo.entrega_status.map(e => e.name)),
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: err,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },
    }
  }, [])

  return { state, localDispatch }
}
